
const m = window.require("js-file-downloader");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
